const occupationTypesTransformer = data => {
  return data?.map((item, index) => {
    return { label: item?.title, value: item?.id }
  })
}

export default occupationTypesTransformer
